export const ATSComparison = () => {
  const traditional = [
    "One recruiter searches your req by hand",
    "Shortlist quality depends on their week, their network",
    "You wait days before the first candidate arrives",
    "Every search starts close to cold",
    "More reqs means the recruiter is stretched thinner",
  ];

  const quantumHire = [
    "AI pre-ranks our entire relevant pool before a human opens the req",
    "Every req draws on the same 5M+ profile corpus",
    "Shortlists land in hours, not after a week of searching",
    "Nothing in the corpus goes cold — it's re-matched against every new role",
    "More reqs run through the engine, not just the recruiter",
  ];

  return (
    <section className="qh-not-ats" id="not-ats">
      <div className="qh-wrap">

        <div className="qh-section-head">
          <span className="qh-tag">
            // The distinction that matters
          </span>

          <h2>
            Same relationship as an agency.
            <br />
            A completely different engine behind it.
          </h2>

          <p>
            A typical agency hands you a recruiter and their week.
            QuantumHire hands you a platform that pre-ranks your entire
            candidate pool before a recruiter even opens the req — the
            same accountability, at a fraction of the search time.
          </p>
        </div>

        <div className="qh-compare">

          {/* Traditional agency */}
          <div className="qh-compare-col old">
            <span className="qh-compare-label">
              A typical recruitment agency
            </span>

            <ul>
              {traditional.map((item, index) => (
                <li key={index}>
                  <span className="mk">
                    {(index + 1).toString().padStart(2, "0")}
                  </span>

                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* QuantumHire */}
          <div className="qh-compare-col new">
            <span className="qh-compare-label">
              The QuantumHire platform
            </span>

            <ul>
              {quantumHire.map((item, index) => (
                <li key={index}>
                  <span className="mk">
                    {(index + 1).toString().padStart(2, "0")}
                  </span>

                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};